import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Table from 'apollo-react/components/Table';
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import ClusterDataModal from './ClusterDataModal';
import { columns } from './columns';
import ExpandableComponent from './ExpandableComponent';
import { TABLE_STYLES } from './styles';
import { useTranslation } from '../../../../../custom-hooks/useTranslation';

const useStyles = makeStyles(TABLE_STYLES);

const ChartDataModal = ({ currentChartData, setCurrentChartData }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [expandedRow, setExpandedRow] = useState(null);
  const [modalId, setModalId] = useState(null);

  const rows = currentChartData ?? [];
  const currentClusterData = rows.find((row) => row.id === modalId)?.clusterData ?? [];

  const addRow = () => {
    setCurrentChartData((prev) => {
      const newRow = {
        id: uuidv4(),
        type: 'formula',
        label: '',
        clusterData: [],
      };

      return Array.isArray(prev) ? [...prev, newRow] : [newRow];
    });
  };

  const deleteRow = (id) => {
    setCurrentChartData((prev) => prev.filter((item) => item.id !== id));
  };

  const editRow = (id, accessor, value) => {
    setCurrentChartData((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [accessor]: value } : item))
    );
  };

  const toggleRow = (id) => {
    setExpandedRow((prev) => (prev === id ? null : id));
  };

  const CustomHeader = () => (
    <Button variant="text" size="small" onMouseDown={addRow}>
      {translateString('Add New Cluster')}
    </Button>
  );

  return (
    <>
      <div className={classes.root}>
        <Table
          title="Chart Data"
          columns={columns}
          rows={rows.map((row) => ({
            ...row,
            key: row.id,
            expanded: expandedRow === row.id,
            currentAccessor: 'label',
            deleteRow,
            editRow,
            toggleRow,
            setModalId,
          }))}
          hidePagination
          CustomHeader={CustomHeader}
          ExpandableComponent={ExpandableComponent}
        />
      </div>
      <ClusterDataModal
        open={!!modalId}
        currentClusterData={currentClusterData}
        handleClose={() => setModalId(null)}
        setCurrentClusterData={(newData) => editRow(modalId, 'clusterData', newData)}
      />
    </>
  );
};

export default ChartDataModal;
